import { Checkbox } from "@/components/ui/checkbox";
import { FormControl, FormLabel } from "@/components/ui/form";
import { BaseQuestionProps } from "../..";

interface MultipleChoiceProps extends BaseQuestionProps {
  className?: string;
  options?: { id: string; label: string }[];
}

export const MultipleChoice: React.FC<MultipleChoiceProps> = ({ options, disabled, field, className }) => {
  return (
    <div className="flex flex-col space-y-2 pt-1">
      {options?.map((option) => (
        <div key={option.id} className="flex items-center space-x-3">
          <FormControl>
            <Checkbox
              className={`${disabled ? "border-slate-500 bg-slate-200" : "border-slate-400"} ${className}`}
              checked={field.value?.includes(option.id)}
              onCheckedChange={(checked) => {
                return checked
                  ? field.onChange([...field.value, option.id])
                  : field.onChange(field.value?.filter((value: string) => value !== option.id));
              }}
              disabled={disabled}
            />
          </FormControl>
          <div className="space-y-1 leading-none">
            <FormLabel className={`font-light text-black ${!disabled ? "cursor-pointer" : "cursor-not-allowed opacity-50"}`}>
              {option.label}
            </FormLabel>
          </div>
        </div>
      ))}
    </div>
  );
};
